import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack} from 'views/components';

import backend from 'utils/backend';

import {JobListings, Footer, Header} from './sections';

const JobBoard = (props) => {
  const progressWrap = props.statusProgressWrap;
  const [jobs, setJobs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const BG_COLOR = 'linear-gradient(180deg, #F6F2EF 0%, #F4EFEA 100%)';

  React.useEffect(() => {
    progressWrap(async () => {
      const filter = [];

      filter.push({key: 'status', value: 'ACTIVE'});

      const jobsData = await backend.career.getJobs(filter);
      setJobs(jobsData);
      setIsLoading(false);
    }, []);
  }, []);

  return (
    <Stack sx={{
      background: BG_COLOR,
      minHeight: '100vh',
    }}>
      <Header />
      <JobListings jobs={jobs} isLoading={isLoading}/>
      <Footer />
    </Stack>
  );
};

JobBoard.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(JobBoard));
